import { memo, useCallback } from 'react';
import { twMerge } from 'tailwind-merge';
import cn from 'classnames';
import { TSuggestItem } from 'src/services/SearchService';
import { Element } from 'src/components';
import SearchItem from './SearchItem';
interface IProps {
    keyword: string;
    suggest: (TSuggestItem & { isTopic: boolean })[];
    resetSuggest: () => void;
    show?: boolean;
}

const SearchDropdown = ({ suggest = [], resetSuggest, show }: IProps) => {
    const renderItems = useCallback(() => {
        return suggest.map((item, index) => (
            <SearchItem
                index={index}
                key={item.id}
                onClick={resetSuggest}
                {...item}
            />
        ));
    }, [suggest]);

    if (!suggest.length) return null;

    return (
        <Element
            className={twMerge(
                'bm-search-dropdown',
                'hidden',
                'overflow-hidden',
                'absolute top-full right-0 z-20',
                'w-full',
                'text-[#292929] text-[12px]',
                'bg-white',
                'shadow-[0_6px_16px_rgb(0_0_0_/_10%)]',
                'rounded-b-[12px]',
                cn({
                    ['block']: show,
                }),
            )}
        >
            <Element renderAs="ul">{renderItems()}</Element>
        </Element>
    );
};

export default memo(SearchDropdown);
